/**
 * @file コンポーネント：モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledModal,
    StyledModalContainer,
    StyledModalContainerButton,
    StyledModalContainerButtonlist,
    StyledModalContainerButtonlistItem,
    StyledModalContainerClose,
    StyledModalContainerContent,
    StyledModalContainerHeadline,
} from "./style";

// 関数読み込み
import { fnSetFixedBody } from "~/src/functions/common";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledModal
            className={[
                props.isShow && "is-show",
                props.cover === "opaque" && "is-opaque",
            ]}
        >
            <StyledModalContainer ref={props.refModalContainer}>
                {/* 見出し */}
                {props.headline && (
                    <StyledModalContainerHeadline
                        dangerouslySetInnerHTML={{
                            __html: props.headline,
                        }}
                    />
                )}
                {/* ×ボタン */}
                {props.hasButtonClose === true && (
                    <StyledModalContainerClose
                        id="js-button-modalclose"
                        onClick={(e) => {
                            e.preventDefault();
                            fnSetFixedBody(false);
                            props.setIsShow(false);
                        }}
                        title={localized["Label.Close"]}
                    >
                        <i className="fas fa-times"></i>
                    </StyledModalContainerClose>
                )}
                {/* 内容 */}
                <StyledModalContainerContent>
                    {props.content}
                </StyledModalContainerContent>
                {/* ボタンリスト */}
                {Array.isArray(props.buttonlist) === true &&
                    props.buttonlist.length > 0 && (
                        <StyledModalContainerButtonlist>
                            {props.buttonlist.map((button, index) => (
                                <StyledModalContainerButtonlistItem
                                    key={"button-" + index}
                                >
                                    <StyledModalContainerButton
                                        className={
                                            button.disabled === true &&
                                            "is-disabled"
                                        }
                                        data-button-type={button.buttonType}
                                        href={button.href ? button.href : "#"}
                                        onClick={button.onClick}
                                    >
                                        {button.text}
                                    </StyledModalContainerButton>
                                </StyledModalContainerButtonlistItem>
                            ))}
                        </StyledModalContainerButtonlist>
                    )}
            </StyledModalContainer>
        </StyledModal>
    );
};
